import { Component, ElementRef, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import Swal from 'sweetalert2';

@Component({
  selector: 'child-cell',
  template: `
    <div class="flex align-items-center list-user-action">
      <div class="custom-action">

        <ng-container *ngIf="showActions || selfAccess">
          <a class="" href="javascript:void(0)" (click)="invokeParentEditMethod()">
              <i *ngIf="!isclosed" title="Edit" class="bx bx-edit text-success me-1 font-size-16"></i>
              <i *ngIf="isclosed" title="View" class="mdi mdi-file-eye text-secondary me-1 font-size-16"></i>
          </a>
        </ng-container>

        <ng-container *ngIf="isclosed && inboundAction && receiversAccess">
          <a class="" href="javascript:void(0)">
            <i class="mdi mdi-format-list-checks text-warning font-size-20 me-1" title="Manage Inbound" (click)="invokeParentEditInboudMethod()"></i>
          </a>
        </ng-container>

        <ng-container *ngIf="printAction">
          <div ngbDropdown container="body" *ngIf="printForComponent === 'ListManifestComponent'">
            <a class="" href="javascript:void(0)" title="Print" ngbDropdownToggle>
              <i class="bx bx-printer text-primary me-1 font-size-16"></i>
              <div ngbDropdownMenu aria-labelledby="dropdownprint" class="dropdown-menu dropdown-menu-end">
                <button ngbDropdownItem (click)="invokeParentPrintMethod('manifest')">Manifest Print</button>
                <button ngbDropdownItem (click)="invokeParentPrintMethod('manifesttiff')">Generate Tiff</button>
                <button ngbDropdownItem (click)="invokeParentPrintMethod('bag')">Bag Print</button>
                <button ngbDropdownItem (click)="invokeParentPrintMethod('exportcsv')">Export CSV</button>
              </div>
            </a>
          </div>
          <div ngbDropdown container="body" *ngIf="printForComponent === 'DRSComponent'" title="Print Options">
            <a class="" href="javascript:void(0)" title="Print" ngbDropdownToggle>
                <i class="bx bx-printer text-primary me-1 font-size-16"></i>
                <div ngbDropdownMenu aria-labelledby="dropdownprint" class="dropdown-menu dropdown-menu-end">
                  <button ngbDropdownItem (click)="invokeParentPrintMethod('print')">Print</button>
                  <button ngbDropdownItem (click)="invokeParentPrintMethod('uploadcopy')">Upload DRS Copy</button>
                  <button ngbDropdownItem (click)="invokeParentPrintMethod('exportexcel')">Export Excel</button>
                </div>
              </a>
            </div>
          </ng-container>
        <ng-container *ngIf="showActions && showDelete"> 
          <a class="" href="javascript:void(0)" title="Delete" (click)="invokeParentDeleteMethod()">
              <i class="bx bx-trash text-delete text-danger me-1 font-size-16"></i>
          </a>
        </ng-container>

        <ng-container  *ngIf="showComment">
          <a  class="" href="javascript:void(0)" title="Add-Comments" (click)="invokeParentAddCommentMethod()">
              <i class="bx bxs-comment-add text-secondary me-1 font-size-16"></i>
          </a>
        </ng-container>

        <ng-container  *ngIf="viewAction">
          <a  class="" href="javascript:void(0)" title="Add-Comments" (click)="invokeParentViewMethod()">
              <i class="mdi mdi-eye me-1"></i>
          </a>
        </ng-container>

        <ng-container  *ngIf="zipAction">
          <a  class="" href="javascript:void(0)" title="Zip-File"  style="cursor:pointer" (click)="invokeParentZipMethod()">
              <i class="mdi mdi-folder-zip-outline me-1 font-size-16"></i>
          </a>
        </ng-container>

        <ng-container *ngIf="showReceipt"> 
          <a class="" href="javascript:void(0)" [title]="ReceiptTitle" (click)="invokeParentReceiptMethod()">
              <i class="bx bx-receipt text-primary me-1 font-size-16"></i>
          </a>
        </ng-container>

        <div ngbDropdown container="body" class="d-inline-block flex-grow-1 flex-end mt-1" *ngIf="more">
            <a class="" href="javascript:void(0)" title="More" ngbDropdownToggle>
                <i class="bx bx-dots-horizontal-rounded text-success me-1 font-size-16"></i>
            </a>
            <div ngbDropdownMenu aria-labelledby="dropdownMore" class="dropdown-menu dropdown-menu-end" *ngIf="updateStatus">
                <button ngbDropdownItem (click)="invokeParentUpdateStatusMethod()"><i class="bx bx-check-square text-secondary me-2"></i>Update Status</button>
            </div>
        </div>

        <ng-container *ngIf="!showActions">
          <i class="text-muted">( View Only )</i>
        </ng-container>
      <div>
    </div>
  `,
  styles: [
    `
      .btn {
        line-height: 0.5;
      }
      .custom-action{
      display: flex; 
      align-items: center;
    }
    `,
  ],
})
export class EditDeleteActionsRenderer implements ICellRendererAngularComp {
  @ViewChild('.checkbox') checkbox: ElementRef;
  public params!: ICellRendererParams;
  showActions = true;
  showComment = false;
  viewAction = false;
  showReceipt = false;
  ReceiptTitle: string = 'Receipt'
  isclosed = false;
  printAction = false;
  receiversAccess = false;
  selfAccess = false;
  isChecked = true;
  rowData: any;
  isDisabled = false;
  inboundAction = false;
  showDelete = true;
  showConfig = false;
  printForComponent = null;
  zipAction = false;
  // tiffAction = false;
  more = false;
  updateStatus = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    // Set initial values based on params and context
    this.rowData = this.params.data;
    this.showComment = this.params.context?.actionConfig?.comment;
    this.printAction = this.params.context?.actionConfig?.printAction;
    
    this.showReceipt = this.params.context?.actionConfig?.showReceipt;
    this.isclosed = this.params?.data?.isclosed;
    this.receiversAccess = this.params.data.recv_access;
    this.selfAccess = this.params.data.self_access;
    this.viewAction = this.params.context?.actionConfig?.viewAction;
    this.inboundAction = this.params.context?.actionConfig?.inboundAction;
    this.isclosed = this.params?.data?.isclosed;
    this.showConfig = this.params.context?.actionConfig?.config;
    this.zipAction = this.params.context?.actionConfig?.zipAction;
    // this.tiffAction = this.params.context?.actionConfig?.tiffAction;
    this.more = params?.context?.actionConfig?.more;
    this.updateStatus = params?.context?.actionConfig?.updateStatus;

    const componentName = this.params.context?.componentName || '';
    const data = this.params?.data;

    if (componentName === 'ListManifestComponent') {
      this.showDelete = data?.transactionstatus !== 'MANIFEST_FINALIZED';
      this.printForComponent = componentName;
    }

    if (componentName === 'DRSComponent') {
      this.showDelete = data?.status === 'DRS_CREATED';
      this.printForComponent = componentName;
    }

    if (componentName === 'ListChargesComponent') {
      const name = data?.name?.toLowerCase();
      this.showDelete = name !== 'freight' && name !== 'discount';
    }

    if (componentName === 'ListHoTransferComponent' && data?.amountrecieved) {
      this.showDelete = false;
      this.showActions = false;
    }

    if(componentName === 'ListCustomerComponent'){
      this.ReceiptTitle = 'Customer Contract'
    }
  }

  public invokeParentEditMethod() {
    this.params.node.data.rowIndex = this.params.node.rowIndex;
    this.params.context.componentParent.editAction(this.params.node.data);
    this.params.node.setSelected(true);
  }

  public invokeParentReceiptMethod() {
    this.params.context.componentParent.ReceiptAction(this.params.node.data);
  }

  public invokeParentDeleteMethod() {
    this.params.context.componentParent.deleteAction(this.params.node.data);
  }

  public invokeParentAddCommentMethod() {
    this.params.context.componentParent.addCommentAction(this.params.node.data);
  }

  public invokeParentEditInboudMethod() {
    this.params.context.componentParent.editInboud(this.params.node.data);
  }

  public invokeParentPrintMethod(printType: string) {
    this.params.context.componentParent.printPDF(this.params.node.data.id, printType);
  }

  public invokeParentViewMethod() {
    this.params.context.componentParent.view(this.params.node.data.id);
  }

  public invokeParentZipMethod() {
    this.params.context.componentParent.zipFile(this.params.node.data.id);
  }

  public invokeParentUpdateStatusMethod() {
    this.params.context.componentParent.updateStatus(this.params.node.data);
  }

  public async onChange(event) {
    const confirmed = await this.openConfirmationDialog('Are you sure?');
    if (confirmed) {
      this.rowData.isopen = false;
      let result = {
        event: event,
        data: this.params,
        rowdata: this.rowData,
        checked: event?.currentTarget?.checked
      }
      // console.log('result',result);

      this.params.context.componentParent.onCheckBoxChange(result);
    } else {
      this.isChecked = false;  // Set to false if the user doesn't confirm
      this.params.api.refreshCells({ rowNodes: [this.params.node], force: true });
    }
  }

  async openConfirmationDialog(msg: any): Promise<boolean> {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    return result.isConfirmed;
  }

  refresh(): boolean {
    return false;
  }
}